import { Models } from '@rematch/core';

/* ENTITIES */
import { floorEntity, storeName as floorEntityStoreName } from './entities/floor.entity';
import { agentEntity, storeName as agentEntityStoreName } from './entities/agent.entity';

import { projectEntity, storeName as projectEntityStoreName } from './entities/project.entity';
import {
  projectChildItemEntity,
  storeName as projectChildItemEntityStoreName,
} from './entities/projectChildItem.entity';
import {
  projectItemEntity,
  storeName as projectItemEntityStoreName,
} from './entities/projectItem.entity';

import { sessionEntity, storeName as sessionEntityStoreName } from './entities/session.entity';

import {
  sharedFilterResultEntity,
  storeName as sharedFilterResultEntityStoreName,
} from './entities/sharedFilterResult.entity';

import {
  termOfContract,
  storeName as termOfContractStoreName,
} from './entities/termOfContract.entity';
import { featureEntity, storeName as featureEntityStoreName } from './entities/feature.entity';

/* MODELS */
import { layoutModel, storeName as layoutModelStoreName } from './models/layout.model';
import { propertiesModel, storeName as propertiesModelStoreName } from './models/properties.model';
import { sessionModel, storeName as sessionModelStoreName } from './models/session.model';
import {
  sharedFilterResultModel,
  storeName as sharedFilterResultModelStoreName,
} from './models/sharedFilterResult.model';
import { userModel, storeName as userModelStoreName } from './models/user.model';

export interface RootModel extends Models<RootModel> {
  /* ENTITIES */
  [floorEntityStoreName]: typeof floorEntity;
  [agentEntityStoreName]: typeof agentEntity;
  [projectEntityStoreName]: typeof projectEntity;
  [projectChildItemEntityStoreName]: typeof projectChildItemEntity;
  [projectItemEntityStoreName]: typeof projectItemEntity;
  [sessionEntityStoreName]: typeof sessionEntity;
  [sharedFilterResultEntityStoreName]: typeof sharedFilterResultEntity;
  [termOfContractStoreName]: typeof termOfContract;
  [featureEntityStoreName]: typeof featureEntity;

  /* MODELS */
  [layoutModelStoreName]: typeof layoutModel;
  [propertiesModelStoreName]: typeof propertiesModel;
  [sessionModelStoreName]: typeof sessionModel;
  [sharedFilterResultModelStoreName]: typeof sharedFilterResultModel;
  [userModelStoreName]: typeof userModel;
}

export const models: RootModel = {
  /* ENTITIES */
  [floorEntityStoreName]: floorEntity,
  [agentEntityStoreName]: agentEntity,
  [projectEntityStoreName]: projectEntity,
  [projectChildItemEntityStoreName]: projectChildItemEntity,
  [projectItemEntityStoreName]: projectItemEntity,
  [featureEntityStoreName]: featureEntity,
  [sessionEntityStoreName]: sessionEntity,
  [sharedFilterResultEntityStoreName]: sharedFilterResultEntity,
  [termOfContractStoreName]: termOfContract,

  /* MODELS */
  [layoutModelStoreName]: layoutModel,
  [propertiesModelStoreName]: propertiesModel,
  [sessionModelStoreName]: sessionModel,
  [sharedFilterResultModelStoreName]: sharedFilterResultModel,
  [userModelStoreName]: userModel,
};
